// Action Types
export const FETCH_NOTIFICATION_CONFIGS = 'dt/notificationConfig/FETCH_NOTIFICATION_CONFIGS';
export const RECEIVE_NOTIFICATION_CONFIGS = 'dt/notificationConfig/RECEIVE_NOTIFICATION_CONFIGS';
export const FETCH_USER_NOTIFICATION_CONFIGS =
  'dt/notificationConfig/FETCH_USER_NOTIFICATION_CONFIGS';
export const RECEIVE_USER_NOTIFICATION_CONFIGS =
  'dt/notificationConfig/RECEIVE_USER_NOTIFICATION_CONFIGS';
export const SET_USER_NOTIFICATION_CONFIGS_LOADING =
  'dt/notificationConfig/SET_USER_NOTIFICATION_CONFIGS_LOADING';
export const CREATE_NOTIFICATION_CONFIG = 'dt/notificationConfig/CREATE_NOTIFICATION_CONFIG';
export const UPDATE_NOTIFICATION_CONFIG = 'dt/notificationConfig/UPDATE_NOTIFICATION_CONFIG';
export const DELETE_NOTIFICATION_CONFIG = 'dt/notificationConfig/DELETE_NOTIFICATION_CONFIG';
export const CONFIG_CREATED = 'dt/notificationConfig/CONFIG_CREATED';
export const CONFIG_UPDATED = 'dt/notificationConfig/CONFIG_UPDATED';
export const CONFIG_DELETED = 'dt/notificationConfig/CONFIG_DELETED';
export const SET_NOTIFICATION_CONFIGS_LOADING =
  'dt/notificationConfig/SET_NOTIFICATION_CONFIGS_LOADING';
export const SET_COPIED_SETTINGS = 'dt/notificationConfig/SET_COPIED_SETTINGS';
export const CLEAR_COPIED_SETTINGS = 'dt/notificationConfig/CLEAR_COPIED_SETTINGS';
export const SYNC_NOTIFICATION_CONFIGS = 'dt/notificationConfig/SYNC_NOTIFICATION_CONFIGS';
export const RESET_ALL_NOTIFICATION_CONFIGS =
  'dt/notificationConfig/RESET_ALL_NOTIFICATION_CONFIGS';

// Action Creators
export const syncNotificationConfigs = ({ org, site }) => ({
  type: SYNC_NOTIFICATION_CONFIGS,
  org,
  site,
});

export const resetAllNotificationConfigs = ({ org, site }) => ({
  type: RESET_ALL_NOTIFICATION_CONFIGS,
  org,
  site,
});

export const receiveNotificationConfigs = (configs, total) => ({
  type: RECEIVE_NOTIFICATION_CONFIGS,
  configs,
  total,
});

export const requestUserNotificationConfigs = (query) => ({
  type: FETCH_USER_NOTIFICATION_CONFIGS,
  query,
});

export const receiveUserNotificationConfigs = (configs, total) => ({
  type: RECEIVE_USER_NOTIFICATION_CONFIGS,
  configs,
  total,
});

export const setUserNotificationConfigsLoading = (loading) => ({
  type: SET_USER_NOTIFICATION_CONFIGS_LOADING,
  loading,
});

export const createNotificationConfig = (data) => ({
  type: CREATE_NOTIFICATION_CONFIG,
  data,
});

export const updateNotificationConfig = (id, data) => ({
  type: UPDATE_NOTIFICATION_CONFIG,
  id,
  data,
});

export const deleteNotificationConfig = (id) => ({
  type: DELETE_NOTIFICATION_CONFIG,
  id,
});

export const configCreated = (config) => ({
  type: CONFIG_CREATED,
  config,
});

export const configUpdated = (config) => ({
  type: CONFIG_UPDATED,
  config,
});

export const configDeleted = (id) => ({
  type: CONFIG_DELETED,
  id,
});

export const setNotificationConfigsLoading = (loading) => ({
  type: SET_NOTIFICATION_CONFIGS_LOADING,
  loading,
});

export const setCopiedSettings = (sourceRole, stateChangeSettings) => ({
  type: SET_COPIED_SETTINGS,
  copiedSettings: { sourceRole, stateChangeSettings },
});
